import { EnvironmentModel, EnvironmentType } from "./models/environment.model";

export const environment: EnvironmentModel = {
  production: false,
  environmentType: EnvironmentType.Dev,
  imagebaseUrl: '/assets/environments/development/',
  apiKey: '',
  auth0: {
    domain: '##AUTH0_DOMAIN##',
    clientId: '##AUTH0_CLIENT_ID1234##',
    httpInterceptor: {
      allowedList: []
    },
    authorizationParams: {
      redirect_uri: 'http://localhost:4200/callback',
      audience: 'MDM_API',
      responseType: 'token id_token',
      scope: 'profile email',
    },
  }
};
